import type { OnInit } from '@angular/core';
import type { WebWidgetEntity } from '@web/types';

import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import {
    indentHeightCss,
    indentMobileHeightCss,
    indentTabletHeightCss,
} from '@sites/entity-core/src/widget/indent/styles/indent.css-vars';
import type { IndentForm } from '@sites/entity-signal-form';

import { WebWidgetSignalFormService } from '@web/core/services/web-widget-signal-form.service';
import { WebBaseViewSignalFormComponent } from '@web/widgets/common/abstract/web-base-view-signal-form.component';

/**
 * Editor preview for the `indent` (spacer) widget. The form is shared with the
 * control panel via `WebWidgetSignalFormService` (ref-counted by widget id). The
 * spacer is an empty box of the `props.height` leaves.
 */
@Component({
    selector: 'web-indent-view',
    templateUrl: './indent-view.component.html',
    styleUrls: ['./indent-view.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IndentViewComponent extends WebBaseViewSignalFormComponent<WebWidgetEntity> implements OnInit {
    private readonly signalFormService: WebWidgetSignalFormService = inject(WebWidgetSignalFormService);

    public form!: IndentForm;

    // --- CSS custom property values (bound on the spacer box) ---
    public readonly height = computed<string | null>(() => indentHeightCss(this.form.heights().value()));
    public readonly tabletHeight = computed<string | null>(() => indentTabletHeightCss(this.form.heights().value()));
    public readonly mobileHeight = computed<string | null>(() => indentMobileHeightCss(this.form.heights().value()));

    public ngOnInit(): void {
        this.form = this.signalFormService.getOrCreateScoped<IndentForm>(this.widget().id, this.destroyRef);
    }
}
